import React from 'react'
import ForgotPasswordForm from '../components/ForgotPasswordForm'

const ForgotPassword = () => {
  return (
    <div className='flex items-center bg-blue-50 justify-center w-full h-screen'>
        <ForgotPasswordForm />
    </div>
  )
}

export default ForgotPassword